import React from "react";
import "./Group20.css";

function Group20(props) {
  const { className } = props;

  return (
    <div className={`group-20 ${className || ""}`}>
      <img className="add-friend-2" src="/img/add-friend-2-2@1x.png" />
    </div>
  );
}

export default Group20;
